import styled from 'styled-components';
export const ConfiguratorWrapper = styled.div`
  display: grid;
  grid-template-columns: 22% 56% 22%;
  height: 100vh;
`;
